import { render } from "./DetailLeft.vue?vue&type=template&id=0ebe7346&scoped=true"
import script from "./DetailLeft.vue?vue&type=script&lang=js"
export * from "./DetailLeft.vue?vue&type=script&lang=js"

import "./DetailLeft.vue?vue&type=style&index=0&id=0ebe7346&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebe7346"]])

export default __exports__